'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.scenario',
configs:[
require('./scenarioConfig')],

components:[
require('./scenarioController'),
require('./directives/dateTimeForWaypoint/dateTimeForWaypointDirective')]});
//# sourceMappingURL=index.js.map
